__turbopack_context__.v({
  "body": "DatasheetTable-module-scss-module__zoKvJW__body",
  "content": "DatasheetTable-module-scss-module__zoKvJW__content",
  "header": "DatasheetTable-module-scss-module__zoKvJW__header",
  "headerTitle": "DatasheetTable-module-scss-module__zoKvJW__headerTitle",
  "label": "DatasheetTable-module-scss-module__zoKvJW__label",
  "rightSection": "DatasheetTable-module-scss-module__zoKvJW__rightSection",
  "row": "DatasheetTable-module-scss-module__zoKvJW__row",
  "rowSpan": "DatasheetTable-module-scss-module__zoKvJW__rowSpan",
  "subheader": "DatasheetTable-module-scss-module__zoKvJW__subheader",
  "table": "DatasheetTable-module-scss-module__zoKvJW__table",
  "value": "DatasheetTable-module-scss-module__zoKvJW__value",
});
